const isInternalIdentifier = (identifier) =>
  identifier ? identifier.toLowerCase().endsWith('@inxits.com') : false;

export const parseSignRequest = (response) => {
  const data = response?.data || null;
  const message = response?.message || '';

  if (!data) {
    return {
      success: false,
      documentId: '',
      tokenId: '',
      identifier: '',
      agreementStatus: '',
      message: message || 'Failed to create agreement sign request'
    };
  }

  const documentId = data.id || '';
  const tokenId = data.access_token?.id || '';

  const parties = data.signing_parties || [];
  const customerParty = parties.find(party => party.identifier && !isInternalIdentifier(party.identifier));
  const identifier = customerParty?.identifier || parties[0]?.identifier || '';

  return {
    success: !!documentId && !!tokenId,
    documentId,
    tokenId,
    identifier,
    agreementStatus: data.agreement_status || '',
    message,
  };
};
